/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';
import React, { Component } from 'react';
import { downloadExcel, excelStyles } from '../../../../shared/services/common-excel-functions';
import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { formatGivenDate } from '../../../../shared/services/common-functions';

class RegionalOrderAvailabilityTable extends Component {

    onGridReady = params => {

        this.gridApi = params.api;

    }

    exportExcel = () => {

        const message = `Regional Order Availability as of ${Date()}.`;
        const title = 'Regional Order Availability';
        const sheetName = 'Regional Order Availability';
        const colSpan = 11;

        downloadExcel( this, message, title, sheetName, colSpan );

    };

    getColumnDefs = () => {

        const colDefs = [];

        colDefs.push(
            {
                field: 'family',
                headerName: '',
                width: 140,
                rowSpan: params => ( params.node.rowIndex % 3 === 0 ) ? 3 : 1,
                cellClassRules: {
                    'cell-span': params => params.value !== undefined,
                    'family-bkground-highlight': params => ( params.node.rowIndex === 0 || params.node.rowIndex === 1 || params.node.rowIndex === 2 )
                },
                pinned: 'left'
            },
            {
                headerName: 'Week',
                children: [
                    {
                        headerName: 'Month',
                        children: [
                            {
                                headerName: 'Ending',
                                field: 'familyDetails',
                                width: 140,
                                cellClassRules: {
                                    'cell-span': params => params.value !== undefined,
                                    'family-bkground-highlight': params => ( params.node.rowIndex === 0 || params.node.rowIndex === 1 || params.node.rowIndex === 2 )
                                },
                                pinned: 'left'
                            }
                        ]
                    }
                ]
            }
        );
        if ( this.props.results ) {

            this.props.results.weeksHeader.forEach( weekObj => {

                let headerName1 = Number( weekObj.weekNumber );
                let headerName2 = `${formatGivenDate( Number( weekObj.week ), 'MM/DD/YYYY' )}`;
                const headerName3 = `${formatGivenDate( Number( weekObj.week ), 'MMM-YY' )}`;
                headerName2 = headerName2.charAt( 0 ).toUpperCase() + headerName2.slice( 1 );
                const dateField = formatGivenDate( Number( weekObj.week ), 'YYYY-MM-DD' );

                if ( dateField === '2000-01-01' ) {

                    headerName1 = 'Inventory';

                } else if ( dateField === '2000-02-01' ) {

                    headerName1 = 'Rework';

                }
                if ( headerName1 === 'Inventory' || headerName1 === 'Rework' ) {

                    colDefs.push(

                        {

                            headerName: `${headerName1}`,
                            field: `${Number( weekObj.week )}`,
                            width: 120,
                            cellClassRules: {
                                'atp-regional-order-availability-result-red-cell': 'x < 0',
                                'family-bkground-highlight': params => ( params.node.rowIndex === 0 || params.node.rowIndex === 1 || params.node.rowIndex === 2 )
                            },
                            cellRenderer: params => {

                                if ( ( params.value > 0 ) && ( params.data.familyDetails === 'Total Ordered' || params.data.familyDetails === 'STK Ordered' ) ) {

                                    return ( <span><Link to={`/${params.data.unitName}/constraints/check-orders-by-constraint-build-weeks?constrainttype=${params.data.ctype}&constraintkey=${params.data.ckey}&beginweek=${params.data.beginWeekEnding}&endweek=${params.data.endWeekEnding}`}>{params.value}</Link></span> );

                                }
                                return ( <span>{params.value}</span> );

                            }
                        }
                    );

                } else {

                    colDefs.push(

                        {
                            headerName: `${headerName1}`,
                            children: [
                                {
                                    headerName: `${headerName3}`,
                                    children: [
                                        {
                                            headerName: `${headerName2}`,
                                            field: `${Number( weekObj.week )}`,
                                            width: 120,
                                            cellClassRules: {
                                                'atp-regional-order-availability-result-red-cell': 'x < 0',
                                                'family-bkground-highlight': params => ( params.node.rowIndex === 0 || params.node.rowIndex === 1 || params.node.rowIndex === 2 )
                                            },
                                            cellRenderer: params => {

                                                if ( ( params.value > 0 ) && ( params.data.familyDetails === 'Total Ordered' || params.data.familyDetails === 'STK Ordered' ) ) {

                                                    return ( <span><Link to={`/${params.data.unitName}/constraints/check-orders-by-constraint-build-weeks?constrainttype=${params.data.ctype}&constraintkey=${params.data.ckey}&beginweek=${params.data.beginWeekEnding}&endweek=${params.data.endWeekEnding}`}>{params.value}</Link></span> );

                                                }
                                                return ( <span>{params.value}</span> );

                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    );

                }

            } );

        }
        return colDefs;

    };

    getTableResult = () => {

        const tableResult = [];
        if ( this.props.results ) {

            this.props.results.regionalOrderResults.forEach( tempResult => {

                let nestedCapacityTDResult = {};
                nestedCapacityTDResult.family = `${tempResult.familyName} Family`;
                nestedCapacityTDResult.ctype = 'F';
                nestedCapacityTDResult.ckey = ( tempResult.familyName ).trim();
                nestedCapacityTDResult.beginWeekEnding = this.props.selectedBeginWeek;
                nestedCapacityTDResult.endWeekEnding = this.props.selectedEndWeek;
                nestedCapacityTDResult.familyDetails = 'Total Capacity';

                let nestedOrderedTDResult = {};
                nestedOrderedTDResult.family = `${tempResult.familyName} Family`;
                nestedOrderedTDResult.ctype = 'F';
                nestedOrderedTDResult.ckey = ( tempResult.familyName ).trim();
                nestedOrderedTDResult.beginWeekEnding = this.props.selectedBeginWeek;
                nestedOrderedTDResult.endWeekEnding = this.props.selectedEndWeek;
                nestedOrderedTDResult.familyDetails = 'Total Ordered';

                let nestedAvailabilityTDResult = {};
                nestedAvailabilityTDResult.family = `${tempResult.familyName} Family`;
                nestedAvailabilityTDResult.ctype = 'F';
                nestedAvailabilityTDResult.ckey = ( tempResult.familyName ).trim();
                nestedAvailabilityTDResult.beginWeekEnding = this.props.selectedBeginWeek;
                nestedAvailabilityTDResult.endWeekEnding = this.props.selectedEndWeek;
                nestedAvailabilityTDResult.familyDetails = 'Total Availability';

                Object.keys( tempResult.regionalFamily ).forEach( item => {

                    const { totalAvailability } = tempResult.regionalFamily[item];
                    nestedCapacityTDResult[item] = tempResult.regionalFamily[item].totalCapacity;
                    nestedOrderedTDResult[item] = tempResult.regionalFamily[item].totalOrdered;
                    nestedAvailabilityTDResult[item] = totalAvailability;

                } );

                tableResult.push( nestedCapacityTDResult );
                tableResult.push( nestedOrderedTDResult );
                tableResult.push( nestedAvailabilityTDResult );

                tempResult.groupOrderList.forEach( grpTempResult => {

                    const { groupName } = grpTempResult;
                    const { groupType } = grpTempResult;
                    let familyHeader = 'STK';
                    if ( groupType === 'REGIONAL' ) {

                        familyHeader = 'Total';

                    }
                    nestedCapacityTDResult = {};
                    nestedCapacityTDResult.family = groupName;
                    nestedCapacityTDResult.ctype = 'G';
                    nestedCapacityTDResult.ckey = ( groupName ).trim();
                    nestedCapacityTDResult.beginWeekEnding = this.props.selectedBeginWeek;
                    nestedCapacityTDResult.endWeekEnding = this.props.selectedEndWeek;
                    nestedCapacityTDResult.familyDetails = `${familyHeader} Capacity`;

                    nestedOrderedTDResult = {};
                    nestedOrderedTDResult.family = groupName;
                    nestedOrderedTDResult.ctype = 'G';
                    nestedOrderedTDResult.ckey = ( groupName ).trim();
                    nestedOrderedTDResult.beginWeekEnding = this.props.selectedBeginWeek;
                    nestedOrderedTDResult.endWeekEnding = this.props.selectedEndWeek;
                    nestedOrderedTDResult.familyDetails = `${familyHeader} Ordered`;

                    nestedAvailabilityTDResult = {};
                    nestedAvailabilityTDResult.family = groupName;
                    nestedAvailabilityTDResult.ctype = 'G';
                    nestedAvailabilityTDResult.ckey = ( groupName ).trim();
                    nestedAvailabilityTDResult.beginWeekEnding = this.props.selectedBeginWeek;
                    nestedAvailabilityTDResult.endWeekEnding = this.props.selectedEndWeek;
                    nestedAvailabilityTDResult.familyDetails = `${familyHeader} Availability`;

                    Object.keys( grpTempResult.groupResults ).forEach( grpItem => {

                        const { stkCapacity } = grpTempResult.groupResults[grpItem];
                        const { stkOrdered } = grpTempResult.groupResults[grpItem];
                        const { stkAvailability } = grpTempResult.groupResults[grpItem];
                        nestedCapacityTDResult[grpItem] = stkCapacity;
                        nestedOrderedTDResult[grpItem] = stkOrdered;
                        nestedAvailabilityTDResult[grpItem] = stkAvailability;

                    } );

                    tableResult.push( nestedCapacityTDResult );
                    tableResult.push( nestedOrderedTDResult );
                    tableResult.push( nestedAvailabilityTDResult );

                } );

            } );

        }

        const additionalInfo = { unitName: this.props.unitCode };
        const agGridResult = tableResult.map( i => ( { ...i, ...additionalInfo } ) );

        return agGridResult;

    };

    render () {

        const columnDefs = this.getColumnDefs();
        const tableResult = this.getTableResult();
        const { message } = this;
        return (

            <section className="atp-search-result-panel regional-order-availability-result-panel ">

                <div className="results-message">
                    {message}
                </div>

                <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
                    <AgGridReactComponent
                        reactNext={true}
                        suppressRowTransform={true}
                        columnDefs={columnDefs}
                        rowData={tableResult}
                        onGridReady={this.onGridReady}
                        excelStyles={excelStyles}
                    />
                </div>

            </section>
        );

    }

}

RegionalOrderAvailabilityTable.propTypes = {
    results: PropTypes.array.isRequired,
    unitCode: PropTypes.string.isRequired,
    selectedBeginWeek: PropTypes.string.isRequired,
    selectedEndWeek: PropTypes.string.isRequired,
    lastWeeks: PropTypes.array.isRequired
};
export default RegionalOrderAvailabilityTable;
